import React, {useState, useEffect} from 'react';

/* This example requires Tailwind CSS v2.0+ */
import { ChatBubbleBottomCenterTextIcon, PaperClipIcon } from '@heroicons/react/20/solid'

import {Button, Spinner, Modal, SelectionInput} from 'player-components';
import './style.css';


const LyricsModal = ({song, lyrics, isOpen, lyricsStatus, onClose}) => {

    const formLyricsString = (lyrics) => {
      return (lyrics || [])
        .map((lyric) => lyric.text)
        .join("\n");
    }

    const renderLyrics = () => {
        return <div className="flex flex-col justify-center align-center text-center">
          <h2 className="text-primary text-lg font-bold flex"><ChatBubbleBottomCenterTextIcon className="w-6 h-6 mr-2"/>Lyrics</h2>
          {lyrics.length > 0 && <textarea readOnly className="lyricPreview" value={formLyricsString(lyrics)}/>}
        </div>
    }

    return <Modal 
        isOpen={isOpen}
        content={renderLyrics()}
        closeLabel={'Close'}
        onClose={onClose}
    />
}

export default LyricsModal;